import { z } from 'zod';

import { baseResponseSchema } from '@/schemas/base.schema';

export const userGoogleLoginRequestSchema = z.void();

export type TUserGoogleLoginRequestSchema = z.infer<
  typeof userGoogleLoginRequestSchema
>;

export const userGoogleLoginResponseSchema = baseResponseSchema.extend({
  data: z.object({
    loginUrl: z.string().url(),
  }),
});

export type TUserGoogleLoginResponseSchema = z.infer<
  typeof userGoogleLoginResponseSchema
>;

export const verifyGoogleLoginRequestSchema = z.object({
  code: z.string(),
});

export type TVerifyGoogleLoginRequestSchema = z.infer<
  typeof verifyGoogleLoginRequestSchema
>;

export const verifyGoogleLoginResponseSchema = baseResponseSchema.extend({
  data: z.object({
    token: z.string(),
  }),
});
export type TVerifyGoogleLoginResponseSchema = z.infer<
  typeof verifyGoogleLoginResponseSchema
>;
